"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GliedAnzahlAbhaengigkeit = void 0;
var GliedAnzahlAbhaengigkeit;
(function (GliedAnzahlAbhaengigkeit) {
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["keine"] = 0] = "keine";
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["ungerade"] = 1] = "ungerade";
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["gerade"] = 2] = "gerade";
})(GliedAnzahlAbhaengigkeit = exports.GliedAnzahlAbhaengigkeit || (exports.GliedAnzahlAbhaengigkeit = {}));
//# sourceMappingURL=GliedAnzahlAbhaengigkeit.js.map